import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useStaticQuery, graphql } from 'gatsby';

import media from 'constants/styles/media';
import { SECTION_IDS } from 'constants/index';
import { Header } from 'components/header';
import { BodyText } from 'components/typography/bodyText';
import { Section } from 'components/layout/Section';

const SList = styled.ul`
    margin-top: 24px;
    padding-left: 18px;
    display: grid;
    gap: 12px;
`;

const SListItem = styled.li`
    font-weight: 800;
    font-size: 18px;
    letter-spacing: 0.01em;
    white-space: pre-line;
`;

const SContainer = styled.div`
    display: flex;
    gap: 34px;
    @media (max-width: ${media.tablet}) {
        flex-direction: column;
    }
`;

const SWrapper = styled.div`
    max-width: 531px;
`;

const SImageWrapper = styled.div`
    max-width: 526px;
    max-height: 414px;
    align-self: center;
    @media (max-width: ${media.mobile}) {
        max-width: 344px;
        max-height: 230px;
    }
`;

const SImage = styled.img`
    width: 100%;
    height: auto;
    border-radius: 16px;
    display: block;
`;

const SBodyText = styled(BodyText)`
    letter-spacing: 0.01em;
    white-space: pre-line;
`;

export const ServiceSection = () => {
    const { t } = useTranslation();

    const { file } = useStaticQuery(graphql`
        query serviceImage {
            file(relativePath: { eq: "construction-worker.png" }) {
                publicURL
            }
        }
    `);

    const bulletKeys = [
        'service-section.bullets.1',
        'service-section.bullets.2',
        'service-section.bullets.3',
        'service-section.bullets.4',
    ] as const;

    return (
        <Section id={SECTION_IDS.SERVICE}>
            <SContainer>
                <SWrapper>
                    <Header text={t('service-section.header')} />
                    <SBodyText>{t('service-section.description')}</SBodyText>
                    <SList>
                        {bulletKeys.map((key) => (
                            <SListItem key={key}>{t(key)}</SListItem>
                        ))}
                    </SList>
                </SWrapper>
                <SImageWrapper>
                    <SImage src={file?.publicURL} alt="Digitalization support" />
                </SImageWrapper>
            </SContainer>
        </Section>
    );
};
